

































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'

export default {
    name: 'pro_hazards_table'

    props:
        component:
            type: String
            required: true
        reload:
            type: Boolean
            required: false
        selected:
            type: Object
            required: false
    watch:
        reload: (new_reload, old_reload)->
            if new_reload != old_reload
                @get_pro_hazards()

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        pro_hazards: []
    computed:
        data_filtered: ()->
            self = @
            data = @pro_hazards.filter (x) ->
                modified = self.date_formatter(x.modified)
                !self.search || modified.includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right
        edit_pro_hazard: (index)->
            @$emit('selected',@data_paged[index])
        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @pro_hazards.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier
            # console.log "PRO_HAZARDS SORT ", @pro_hazards

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        download_file: (pro_hazard)->
            url = settings.backend_url+pro_hazard.file_url
            console.log("url", url)              
            filename = pro_hazard.file
            ext = url.split('.').pop();  
            if ext.length < 5
                filename += "."+ext
            t.download_file(url, filename)
            return

        delete_pro_hazard: (pro_hazard_uid)->
            @$emit('delete-prohazard', pro_hazard_uid)
            return

        get_pro_hazards: ()->
            self = @
            @loading = true
            q.run('get_pro_hazard_set', [@$store.getters.current_company.uid, @component])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error(self.component+"_pro_hazards: get_pro_hazards: then", e.message)
                else
                    # console.log "GET pro_hazards : ", resp.body.data.pro_hazard_set
                    self.pro_hazards = resp.body.data.pro_hazard_set
                    self.loading = false
                    if self.pro_hazards.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "pro_hazards_table: get_pro_hazards()")
            
    beforeMount: ()->
        # console.log "pro_hazards_table mounted"
        @get_pro_hazards()
}
